import { useEffect, useState } from 'react';
import { useSystem } from '@ohif/core';
import { SeriesLabelService, SeriesLabels } from '../services/SeriesLabelService';

export function useSeriesLabels(
  studyInstanceUid?: string,
  seriesInstanceUid?: string
): SeriesLabels | null {
  const { servicesManager } = useSystem();
  const { seriesLabelService } = servicesManager.services;

  const [entry, setEntry] = useState<SeriesLabels | null>(() =>
    seriesInstanceUid ? seriesLabelService.get(seriesInstanceUid) : null
  );

  useEffect(() => {
    if (!studyInstanceUid || !seriesInstanceUid) {
      setEntry(null);
      return undefined;
    }

    const apply = () => setEntry(seriesLabelService.get(seriesInstanceUid));

    const { unsubscribe } = seriesLabelService.subscribe(
      SeriesLabelService.EVENTS.SERIES_LABELS_CHANGED,
      event => {
        if (event.seriesInstanceUid === seriesInstanceUid) {
          apply();
        }
      }
    );

    apply();
    void seriesLabelService.request(studyInstanceUid, seriesInstanceUid);

    return unsubscribe;
  }, [seriesLabelService, studyInstanceUid, seriesInstanceUid]);

  return entry;
}
